import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthScreenComponent } from '@app/authorization/components/auth-screen/auth-screen.component';
import { LoginScreenComponent } from '@app/authorization/components/login-screen/login-screen.component';
import { RestoreAccessScreenComponent } from '@app/authorization/components/restore-access-screen/restore-access-screen.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path: '',
				component: AuthScreenComponent,
				children: [
					{
						path: '',
						component: LoginScreenComponent
					},
					{
						path: 'restore',
						component: RestoreAccessScreenComponent
					}
				]
			}
		])
	],
	exports: [
		RouterModule
	]
})

export default class AuthRoutingModule {
}
